<script setup>
/**
 * FormControlAccountSettingsSecondaryDomains
 * Replaces 'extends: FormControlTypeTextarea' with Composition.
 * Validates that secondary domains do not include restricted system domains.
 */
import { watch, getCurrentInstance } from 'vue';
import FormControlTypeTextarea from '../form-control-type/FormControlTypeTextarea.vue';

const props = defineProps({
    // Full Orchestrator Prop Contract
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: String,
        default: ''
    }
});

const { proxy } = getCurrentInstance();

// --- Methods ---

/**
 * Validates the input and syncs error states to the UI and DOM.
 * @param {string} msg
 */
const validate = (msg) => {
    props.field.error = msg;

    /**
     * Accessing the base component's ref.
     * Note: FormControlTypeTextarea must have ref="field" on its <textarea>.
     */
    const el = proxy.$refs.baseControl?.$refs.field;

    if (el) {
        el.setCustomValidity(msg);
        el.checkValidity();
    }
};

// --- Watchers ---

watch(() => props.value, (newValue) => {
    validate('');

    const restrictedDomains = [
        'creativecms.io'
    ];

    restrictedDomains.forEach((domain) => {
        if (newValue && newValue.includes(domain)) {
            const msg = `<strong>${domain}</strong> domains may not be used.`;
            validate(msg);
        }
    });
}, { immediate: true });
</script>

<template>
    <FormControlTypeTextarea
        ref="baseControl"
        v-bind="$props"
        v-on="$listeners"
    />
</template>

<style scoped>
/* Scoped styles inherited from base or added for this specific field */
</style>